import OrderHistoryPage from './OrderHistoryPage';

export default OrderHistoryPage;
